/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.query.account" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.query.userName" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.query.phone" placeholder="输入手机号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
<!--        <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button>-->
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="account" label="用户名"/>
      <el-table-column prop="phone" label="手机号"/>
      <el-table-column prop="userName" label="姓名"/>
      <el-table-column prop="createTime" label="创建时间" >
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" label="最后登录时间">
        <template slot-scope="scope">
          <div>{{scope.row.lastLoginTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="locked" label="是否被锁">
        <template slot-scope="scope">
          {{ scope.row.locked == '0' ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column align="center"  label="操作" width="300">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-show="scope.row.systemFlag != 1"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="解锁"
            placement="top"
          >
            <el-button
              size="mini"
              type="success"
              icon="el-icon-unlock"
              @click="unLockUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="数据权限"
            placement="top"
          >
            <el-button
              size="mini"
              type="success"
              icon="el-icon-menu"
              @click="dataAccess(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="重置密码"
            placement="top"
            v-show="userInfo.systemFlag == 1"
          >
            <el-button
              size="mini"
              type="success"
              icon="el-icon-setting"
              @click="openPwd(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" v-show="scope.row.systemFlag != 1">删除</el-button>
          <el-button size="mini" type="success" @click="unLockUser(scope.$index, scope.row)">解锁</el-button>
          <el-button size="mini" type="success" @click="dataAccess(scope.$index, scope.row)">数据权限</el-button>
          <el-button size="mini" type="success" @click="openPwd(scope.$index, scope.row)" v-show="userInfo.systemFlag == 1">重置密码</el-button>
          <el-button size="mini" type="success" @click="refreshCache(scope.$index, scope.row)">刷新缓存</el-button> -->
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="form" :model="form" :rules="rules">
        <el-form-item label="客户" prop="orgId">
          <el-select size="small" style="width: 100%" filterable v-model="form.orgId" placeholder="请选择客户">
            <el-option
              v-for="x in orgList"
              :label="x.orgName"
              :value="x.orgId"
              :key="x.orgId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-input size="small" maxLength="255" v-model="form.account" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input size="small" maxLength="255" v-model="form.userName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" v-show="!form.userSeqId">
          <el-input size="small" maxLength="200" v-model="form.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input size="small" maxLength="255" v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 数据权限 -->
    <el-dialog title="数据权限" :visible.sync="dataAccessshow" width="30%" :close-on-click-modal="false" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all :data="roleList" :props="defaultProps" :default-checked-keys="checkmenu" node-key="roleSeqId" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>


    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="pwdShow" width="30%" :close-on-click-modal="false" @click='closeDialog("pwd")'>
      <el-form label-width="80px" ref="pwdForm" :model="form">
        <el-form-item label="密码" prop="password">
          <el-input size="small" maxLength="200" v-model="form.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="twoPassword">
          <el-input size="small" maxLength="200" v-model="form.twoPassword" placeholder="请确认登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("pwd")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="resetpwd()">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  editUser,
  addUser,
  removeUser,
  unLockUser,
  userDetail,
  getUserRoleList,    // 获取 对应用户 绑定的 角色
  addFillRole,        // 给用户 添加 角色
  roleList,    // 获取 全部角色列表
  editOtherUserPassword, queryOrgList, queryOrgListNotPage   // 管理员为其他用户修改密码
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { timestampToTime } from '../../utils/util'

export default {
  data() {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[345789]\d{9}$/
      if (value != undefined && value != '') {
        if (regMobile.test(value)) {
          return callback()
        }
        // 返回一个错误提示
        callback(new Error('请输入合法的手机号码'))
      } else {
        callback()
      }
    }
    return {
      userInfo: JSON.parse(localStorage.getItem('userdata')),  // 用户信息
      loading: false, //是显示加载
      title: '添加用户',
      editFormShow: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      form: {},
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        /*password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],*/
        phone: [
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      pwdShow: false,
      // 请求数据参数
      queryParams: {
        currentPage: 1,
        pageSize: 10,
        query: {

        }
      },
      //用户数据
      userData: [],
      orgList: [],
      // 数据权限
      roleList: [],
      defaultProps: {
        children: 'children',
        label: 'roleName'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.initDate()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initDate() {
      this.getdata();
      this.findRoleList();
      this.findOrgList();
    },
    findOrgList() {
      queryOrgListNotPage().then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.orgList = res.data
        }
      })
    },
    // 获取 全部角色
    findRoleList() {
      roleList(JSON.stringify({query: {}})).then(res => {
        if (res.code == 200) {
          this.roleList = res.data.list;
        }
      })
    },

    // 获取数据方法
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      userList(JSON.stringify(this.queryParams)).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data.list
          // 分页赋值
          this.pageparm = res.data.pageParam
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.currentPage = parm.currentPage
      this.queryParams.pageSize = parm.pageSize
      this.getdata()
    },
    //搜索事件
    search() {
      /*if (this.queryParams.query.areaCode) {
        this.queryParams.query.areaCode = this.queryParams.query.areaCode[this.queryParams.query.areaCode.length - 1]
      }*/
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改用户'
        userDetail(row.userSeqId).then(res => {
          this.form = res.data
        })
        // this.form = JSON.parse(JSON.stringify(row));
      } else {
        this.title = '添加用户'
        this.form = {};
      }
    },

    beforeAvatarUpload(file) {
      console.log('file===', file);
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          /*if (this.form.areaCode) {
            if (typeof (this.form.areaCode) != 'string' && this.form.areaCode.length > 0) {
              this.form.areaCode = this.form.areaCode[this.form.areaCode.length - 1]
            }
          }*/
          // 请求方法
          if (this.form.userSeqId) {

            // 修改
            editUser(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })
          } else {

            // 新增
            addUser(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {};
        this.editFormShow = false
      } else if (dialog == 'perm') {
        this.checkmenu = [];
        this.dataAccessshow = false
      } else if (dialog == 'pwd') {
        this.pwdShow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除 ' + row.userName + ' 用户吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          removeUser(JSON.stringify([row.userSeqId])).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '用户 ' + row.userName + ' 删除成功！'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    // 解锁用户
    unLockUser(index, row) {
      this.$confirm('确定要解锁 ' + row.userName + ' 用户吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          unLockUser({userSeqId: row.userSeqId}).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '用户' + row.userName + '解锁成功！'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('解锁失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 打开修改密码弹出框
    openPwd(index, row) {
      this.pwdShow = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 重置密码
    resetpwd() {
      if (this.form.password != this.form.twoPassword) {
        this.$message({
          type: 'error',
          message: '两次密码不一致！'
        })
        return;
      }
      this.$confirm('确定要修改密码吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          editOtherUserPassword(JSON.stringify(this.form)).then(res => {
            this.pwdShow = false;
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '修改密码成功！'
              })
              this.form = {}
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.pwdShow = false;
            this.loading = false
            this.$message.error('修改密码失败，请稍后再试！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改密码！'
        })
      })
    },
    // 数据权限
    dataAccess: function(index, row) {
      this.dataAccessshow = true
      this.saveroleId = row.userSeqId
      getUserRoleList(row.userSeqId).then(res => {
        if (res.code == 200) {
          // 处理 角色权限回显
          this.changemenu(res.data)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('获取角色失败，请稍后再试！')
      })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []

      this.roleList.forEach(res => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].roleSeqId ==  res.roleSeqId) {
            change.push(arr[i].roleSeqId)
          }
        }
      })
      if (change.length > 0) {
        this.$refs.tree.setCheckedKeys(change, true)
      } else {
        this.$refs.tree.setCheckedKeys(change, false)
      }
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        userSeqId: this.saveroleId,
        roleIds: []
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].roleSeqId)
        }
        parm.roleIds = moduleIds
      }
      addFillRole(parm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '角色绑定成功'
          })
          this.dataAccessshow = false
          this.getdata()
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('角色绑定失败，请稍后再试！')
      })
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

/* 头像上传 */
/deep/ .avatar-uploader .el-upload {
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}

</style>




// WEBPACK FOOTER //
// src/views/system/user.vue